module.exports = __webpack_public_path__ + "static/media/oneshelf-pic8.13807daf.JPG";